
<h1 mat-dialog-title>{{ 'GOAL_INFORMATION_DIALOG.TITLE' | translate }}</h1>
<div mat-dialog-content>
    <dynamic-text [content]="contentUrl" [useCard]="false"></dynamic-text>
</div>
<div mat-dialog-actions class="flex-h flex-end">
    <button mat-flat-button color="primary" [mat-dialog-close]>{{ 'GOAL_INFORMATION_DIALOG.CLOSE' | translate }}</button>
</div>
